export default __webpack_public_path__ + "static/media/ic_search.5cca3074.svg";